import { render, staticRenderFns } from "./addSla.vue?vue&type=template&id=0cbe0b6e&scoped=true&"
import script from "./addSla.vue?vue&type=script&lang=js&"
export * from "./addSla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe0b6e",
  null
  
)

export default component.exports